import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Condtional.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { CONDITIONAL_NODE_DESCRIPTION, NodeTypes } from '../../utils';

export const ConditionalNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Conditional' description={CONDITIONAL_NODE_DESCRIPTION} nodeType={NodeTypes.CONDITIONAL} imgPath={stepIcon} />
}